/**
 * Created by Victor Rojo on 9/5/19.
 */
import {Component, Input, OnDestroy} from '@angular/core';

import {PumpWidget} from "../../widget/Widget";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {Pump} from "../../ipetrol/Pump";


@Component({
  selector: 'mock',
  templateUrl: './Mock.component.html',
  styleUrls: ['./Mock.component.css']
})
export class MockComponent {

  @Input()
  title:string;
  @Input()
  subtitle:string;
  @Input()
  image:string;

  constructor() {
  }
}
